import {FC, useState} from 'react';
import {Control, Controller, UseFormSetValue} from 'react-hook-form';

import {Autocomplete, Chip, CircularProgress, FormControl, Stack, TextField, Typography} from '@mui/material';

import {IAccountGroup} from '../../../shared/types/user-account-groups.types';
import {useSearchStrategy} from '../../../hooks/useSearchStrategy';
import {IGroupSelectOption, searchGroupStrategy} from '../../../api/strategies/searchGroupsStrategy';

interface IChooseGroup {
  control: Control<any, any>;
  from: IAccountGroup;
  to: IGroupSelectOption | null;
  setValue: UseFormSetValue<any>;
  loading: boolean;
}

const chipStyle = {
  width: 'fit-content',
  maxWidth: '419px',
  '& .MuiChip-label': {
    fontSize: '14px',
  },
};

export const ChooseGroup: FC<IChooseGroup> = ({from, control, setValue, loading, to}) => {
  const [openSelect, setOpenSelect] = useState(false);
  const {handleSearch, data, searchLoading, searchTerm} = useSearchStrategy<IGroupSelectOption>(searchGroupStrategy);

  return (
    <Stack direction="column" spacing={4}>
      <Stack direction="row" spacing={1.5} sx={{margin: '8px !important'}} alignItems="center">
        <Typography color="#000000de" sx={{ml: 1}} variant="caption">
          Откуда:
        </Typography>
        <Chip sx={chipStyle} label={from.name} />
      </Stack>
      <FormControl variant="standard" sx={{m: '8px !important', minWidth: 120}}>
        {to ? (
          <Stack direction="row" spacing={1.5} sx={{margin: '8px !important'}} alignItems="center">
            <Typography color="#000000de" sx={{ml: '13px'}} variant="caption">
              Куда:
            </Typography>
            <Chip sx={chipStyle} onDelete={() => setValue('preliminaryAnotherGroup', null)} label={to.value.name} />
          </Stack>
        ) : (
          <Controller
            rules={{
              required: 'Обязательно для заполнения',
            }}
            control={control}
            name="region"
            render={({field: {value}, fieldState: {error}}) => (
              <Autocomplete
                open={openSelect}
                disabled={loading}
                onOpen={() => {
                  setOpenSelect(true);
                }}
                onClose={() => {
                  setOpenSelect(false);
                }}
                onChange={(_, newValue) => {
                  setValue('preliminaryAnotherGroup', newValue as IGroupSelectOption);
                }}
                value={value}
                getOptionLabel={(option) => option.label}
                inputValue={searchTerm}
                onInputChange={(_, newInputValue) => {
                  handleSearch(newInputValue);
                }}
                options={data.filter((i) => i.value.id !== from.id)}
                loading={searchLoading}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    autoFocus
                    label="Куда:"
                    size="small"
                    error={!!error}
                    helperText={error ? error.message : ''}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {searchLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            )}
          />
        )}
      </FormControl>
    </Stack>
  );
};
